import audioLanguageReducer from "./modules/audioLanguage/reducer";
import authReducer from "./modules/auth/reducer";
import categoryReducer from "./modules/category/reducer";
import closeCaptionReducer from "./modules/closeCaption/reducer";
import courseReducer from "./modules/course/reducer";
import courseLevelReducer from "./modules/courseLevel/reducer";
import enrollmentReducer from "./modules/enrollment/reducer";
import instructorCourseReducer from "./modules/instructorCourse/reducer";
import ordersReducer from "./modules/orders/reducer";
import subscriptionReducer from "./modules/subscription/reducer";
import { userReducer } from "./modules/user/reducer";
import layoutReducer from "./modules/layout/reducer";
import reviewReducer from "./modules/review/reducer";
import uploadReducer from "./modules/upload/reducer";
import balanceReducer from "./modules/balance/reducer";

const rootReducer = {
  category: categoryReducer,
  auth: authReducer,
  course: courseReducer,
  instructorCourse: instructorCourseReducer,
  user: userReducer,
  orders: ordersReducer,
  courseLevel: courseLevelReducer,
  audioLanguage: audioLanguageReducer,
  closeCaption: closeCaptionReducer,
  enrollment: enrollmentReducer,
  subscription: subscriptionReducer,
  layout: layoutReducer,
  review: reviewReducer,
  upload: uploadReducer,
  balance: balanceReducer,
};

export default rootReducer;
